<template lang='pug'>
    div
        OtherPDSensorSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                    h1.product-title TEV-CP
                    h2.product-subtitle Transient Earth Voltage (TEV) Partial Discharge Sensor for Medium-Voltage Switchgear

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                            img( src='@/assets/photos/TEVSensor.png', width="50%", alt='PD Sensor TEV-CP', title='PD Sensor TEV-CP')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Capacitive Transient Earth Voltage PD sensor
                                li Non-intrusive measurement at MV switchgears
                                li Quick installation using a magnet mount
                                li Bandwidth: 5 MHz … 100 MHz
                        .bluebox
                            Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet TEV-CP.pdf")
                            Maillink(to='support@bss-hs.de', sub='TEV-CP', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/pdm-600", text='PD Monitoring System PDM-600')
                            Sitelink(to="/en/products/pdm-600-mobile", text='PDM-600-Mobile')

            section.margin-bottom
                p The capacitive sensor is designed for partial discharge (PD) measurement on medium-voltage switchgear and other metal-enclosed electrical equipment. It enables reliable detection of internal partial discharges without the need for direct access to live components.
                p The sensor is mounted externally on the equipment enclosure using a magnetic holder. It detects transient earth voltage (TEV) signals that result from PD activity inside the housing. The TEV measurement principle is based on the high-frequency propagation of PD-induced currents along the surface of the metallic enclosure.
                p For non-magnetic enclosures, the sensor can be securely attached using a tension belt.


        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title TEV-CP
                h2.product-subtitle "Transient Earth Voltage" (TEV) Teilentladungssensor für Mittelspannungsschaltanlagen

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                            img( src='@/assets/photos/TEVSensor.png', width="50%", alt='TE-Sensor TEV-CP', title='TE-Sensor TEV-CP')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Kapazitiver Transient Earth Voltage Teilentladungssensor
                                li Berührungslose Messung an Mittelspannungsschaltanlagen
                                li Schnelle Installation mit Magnetbefestigung
                                li Bandbreite: 5 MHz … 100 MHz
                        .bluebox
                            Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet TEV-CP.pdf")
                            Maillink(to='support@bss-hs.de', sub='TEV-CP', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/pdm-600", text='TE-Monitoringsystem PDM-600')
                            Sitelink(to="/de/products/pdm-600-mobile", text='PDM-600-Mobile')
                        
            section.margin-bottom
                p Der kapazitive Sensor ist für die Messung von Teilentladungen (TE) an Mittelspannungsschaltanlagen und anderen metallgekapselten elektrischen Betriebsmitteln ausgelegt. Er ermöglicht eine zuverlässige Erkennung interner Teilentladungen, ohne dass ein direkter Zugang zu spannungsführenden Komponenten erforderlich ist.
                p Der Sensor wird außen am Gehäuse des Betriebsmittels mittels Magnetbefestigung angebracht. Er detektiert Transient Earth Voltage (TEV)-Signale, die durch Teilentladungsaktivität im Inneren des Gehäuses entstehen. Das TEV-Messprinzip basiert auf der hochfrequenten Ausbreitung von durch Teilentladungen induzierten Strömen entlang der Oberfläche des Metallgehäuses.
                p Für nicht-magnetische Gehäuse kann der Sensor sicher mit einem Spanngurt befestigt werden.
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | TEV-CP",
            description:
                "Transient Earth Voltage (TEV) Teilentladungssensor für Mittelspannungsschaltanlagen",
        },
        en: {
            title: "BSS | TEV-CP",
            description:
                "Transient Earth Voltage (TEV) Partial Discharge Sensor for Medium-Voltage Switchgear",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>